<div role="alert"
     class="validation-error"
     [hidden]="control.valid || !(control.touched || form?.submitted)">
    {{ control.errors | validate | translate : {'object' : control.value} }}
</div>
